import { TableName } from '@/enums/tableName.enum';
import { Fee } from '@/interfaces/fee';
import { FeeFilters } from '@/interfaces/filters/feeFilters';
import { FeeResource, feeResource } from '@/resources/fee.resource';
import events from '@/store/modules/fee/events.module';
import presences from '@/store/modules/fee/presence.module';
import { EntityModule } from './entity.module';

/**
 * Składki grupy treningowej
 *
 * @export
 * @class FeeModule
 * @extends {EntityModule<Fee, FeeResource>}
 */
export class FeeModule extends EntityModule<Fee, FeeResource> {
  public modules = { events, presences };

  constructor() {
    super(feeResource);

    const superList = this.actions.list;
    const superAdd = this.actions.add;
    this.state = {
      ...this.state,
      entityType: undefined
    };
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: (context: any, filters: FeeFilters): Promise<void> => {
        context.rootState.fee.entityType === TableName.Team
          ? (filters.teamId = context.rootState.team.id)
          : (filters.clubId = context.rootState.club.id);
        return superList(context, filters);
      },
      /**
       * Dodaje nową składkę
       *
       * @param context context
       * @param data dane
       */
      add: (context: any, data: any): Promise<void> => {
        context.rootState.fee.entityType === TableName.Team
          ? (data.teamId = context.rootState.team.id)
          : (data.clubId = context.rootState.club.id);
        return superAdd(context, data);
      }
    };
    this.mutations = {
      ...this.mutations,
      /**
       * Ustawia rodzaj encji
       *
       * @param {*} localState
       * @param {TableName} entityType
       */
      setEntityType(localState: any, entityType: TableName): void {
        localState.entityType = entityType;
      }
    };
  }
}

export default new FeeModule();
